import { Box } from "@mui/material";
import styled from "styled-components";

interface IHeadingStyled {
  height?: string;
  width?: string;
  flex?: string;
  flexWrap?: string;
  flexDirection?: string;
  alignItems?: string;
  backgroundColor?: string;
  justifyContent?: string;
  alignSelf?: string;
  float?: string;
  margin?: string;
  marginHover?: string;
  padding?: string;
  textAlign?: string;
  $borderRadius?: string;
  border?: string;
  borderTop?: string;
  borderLeft?: string;
  overflow?: string;
  overflowY?: string;
  borderBottom?: string;
  borderHover?: string;
  $cursorHover?: string;
  borderRadiushover?: string;
  boxShadowHover?: string;
  elevation?: number;
  elevationHover?: number;
  $backgroundHover?: string;
  color?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  $colorHover?: string;
  position?: string;
  minHeight?: string;
  maxHeight?: string;
  zIndex?: string;
  $backgroundAfter?: string;
  $heightAfter?: string;
  $contentAfter?: string;
  $positionAfter?: string;
  $bottomAfter?: string;
  $leftAfter?: string;
  $rightAfter?: string;
  transition?: string;
  $borderBottomLeftRadius?: string;
  $borderBottomRightRadius?: string;
  $borderTopRightRadius?: string;
  $borderTopLeftRadius?: string;
}

export const FlexContainer = styled(Box)<IHeadingStyled>`
  height: ${(props) => props.height};
  min-height: ${(props) => props.minHeight};
  max-height: ${(props) => props.maxHeight};
  width: ${(props) => props.width};
  flex: ${(props) => props.flex};
  flex-wrap: ${(props) => props.flexWrap};
  display: flex;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
  flex-direction: ${(props) => props.flexDirection};
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  background-color: ${(props) => props.backgroundColor};
  align-self: ${(props) => props.alignSelf};
  float: ${(props) => props.float};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  border: ${(props) => props.border};
  border-top: ${(props) => props.borderTop};
  border-left: ${(props) => props.borderLeft};
  border-radius: ${(props) => props.$borderRadius};
  border-bottom: ${(props) => props.borderBottom};
  overflow: ${(props) => props.overflow};
  overflow-y: ${(props) => props.overflowY};
  box-shadow: ${(props) => (props.elevation ? elevation[props.elevation] : "")};
  color: ${(props) => props.color};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  left: ${(props) => props.left};
  color: ${(props) => props.color};
  position: ${(props) => props.position};
  z-index: ${(props) => props.zIndex};
  transition: ${(props) => props.transition};
  border-bottom-left-radius: ${(props) => props.$borderBottomLeftRadius};
  border-bottom-right-radius: ${(props) => props.$borderBottomRightRadius};
  border-top-right-radius: ${(props) => props.$borderTopRightRadius};
  border-top-left-radius: ${(props) => props.$borderTopLeftRadius};
  &:hover {
    border: ${(props) => props.borderHover};
    cursor: ${(props) => props.$cursorHover};
    border-radius: ${(props) => props.borderRadiushover};
    box-shadow: ${(props) =>
      props.elevationHover ? elevation[props.elevationHover] : ""};
    background: ${(props) => props.$backgroundHover};
    color: ${(props) => props.$colorHover};
    margin: ${(props) => props.marginHover};
  }
  &::after {
    background-color: ${(props) => props.$backgroundAfter};
    height: ${(props) => props.$heightAfter};
    content: ${(props) => props.$contentAfter};
    position: ${(props) => props.$positionAfter};
    bottom: ${(props) => props.$bottomAfter};
    left: ${(props) => props.$leftAfter};
    right: ${(props) => props.$rightAfter};
  }
`;

const elevation = [
  "none",
  "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
  "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
  "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
  "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
  "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
  "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
  "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
  "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
  "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
  "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
  "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
  "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
  "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
  "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
  "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
  "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
  "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
  "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
  "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
  "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
  "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
  "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
  "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
];
